<template>
    <div class="suspend-container">
        <div class="company-logo-header">
            <img src="https://static.supsis.live/common/supsisAiLogo.png" alt="Supsis Logo" />
        </div>

        <div class="suspend-content">
            <div class="icon-container">
                <div class="suspend-icon">
                    <svg width="40" height="40" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="18" y="26" width="24" height="20" rx="3" fill="white" stroke="white" stroke-width="2"/>
                        <path d="M24 26V18C24 14.6863 26.6863 12 30 12C33.3137 12 36 14.6863 36 18V26" stroke="white" stroke-width="3" stroke-linecap="round"/>
                        <circle cx="30" cy="34" r="2" fill="#f16a52"/>
                        <rect x="29" y="36" width="2" height="6" rx="1" fill="#f16a52"/>
                        <line x1="14" y1="15" x2="14" y2="45" stroke="white" stroke-width="2" stroke-linecap="round" opacity="0.6"/>
                        <line x1="46" y1="15" x2="46" y2="45" stroke="white" stroke-width="2" stroke-linecap="round" opacity="0.6"/>
                    </svg>
                </div>
            </div>

            <h1 class="suspend-title">Hesabınız Askıya Alınmıştır</h1>

            <p class="suspend-description">
                Hesabınızın tekrar aktif hale getirilmesi için lütfen aşağıdaki iletişim kanallarından bizimle iletişime geçin.
            </p>

            <div class="contact-info">
                <div class="contact-item">
                    <div class="contact-icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                            <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="#f16a52" stroke-width="2"/>
                            <polyline points="22,6 12,13 2,6" stroke="#f16a52" stroke-width="2"/>
                        </svg>
                    </div>
                    <div class="contact-details">
                        <div class="contact-label">E-mail</div>
                        <div class="contact-value">info@supsis.com</div>
                    </div>
                </div>

                <div class="contact-divider"></div>

<!--                <div class="contact-item">-->
<!--                    <div class="contact-icon">-->
<!--                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">-->
<!--                            <path d="M22 16.92V19.92C22 20.92 21.11 21.92 20.12 21.92C9.06 21.92 2 14.86 2 3.92C2 2.92 3 2.02 4 2.02H7C7.93 2.02 8.84 2.92 8.84 3.92V7.02C8.84 7.92 8.04 8.72 7.04 8.72H5.04C5.04 13.26 8.58 16.82 13.04 16.82V14.82C13.04 13.82 13.84 13.02 14.84 13.02H17.84C18.84 13.02 19.84 13.92 19.84 14.92V16.92H22Z" stroke="#f16a52" stroke-width="2"/>-->
<!--                        </svg>-->
<!--                    </div>-->
<!--                    <div class="contact-details">-->
<!--                        <div class="contact-label">Telefon & WhatsApp</div>-->
<!--                        <div class="contact-value">+90 216 232 22 82</div>-->
<!--                    </div>-->
<!--                </div>-->

                <div class="contact-button-container">
                    <button class="contact-button" @click="connectSupportTeam">
                        <span class="contact-button-icon">💬</span>
                        <span>İletişime Geç</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { publishMessage, SystemMessageTypes } from "../../utils/systemPubSub";

export default {
    name: "SuspendComponent",
    methods: {
        connectSupportTeam() {
            publishMessage(SystemMessageTypes.CONNECT_SUPPORT_TEAM, {});
        }
    }
};
</script>

<style scoped>
.suspend-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background:
        linear-gradient(90deg, #e5e7eb 1px, transparent 1px),
        linear-gradient(180deg, #e5e7eb 1px, transparent 1px),
        #ffffff;
    background-size: 20px 20px;
    background-position: 0 0, 0 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 999999;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    padding: 40px 20px;
}

.company-logo-header {
    margin-bottom: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(8px);
    padding: 16px 24px;
    border-radius: 12px;
    box-shadow:
        0 8px 24px rgba(0, 0, 0, 0.06),
        0 4px 8px rgba(0, 0, 0, 0.04);
    border: 1px solid rgba(0, 0, 0, 0.05);
}

.company-logo-header img {
    height: 56px;
    width: auto;
    transition: transform 0.3s ease;
}

.company-logo-header img:hover {
    transform: scale(1.05);
}

.suspend-content {
    background: #ffffff;
    padding: 48px;
    border-radius: 16px;
    text-align: center;
    max-width: 520px;
    width: 90%;
    box-shadow:
        0 20px 60px rgba(0, 0, 0, 0.08),
        0 8px 24px rgba(0, 0, 0, 0.06),
        0 4px 8px rgba(0, 0, 0, 0.04);
    border: 1px solid rgba(0, 0, 0, 0.05);
    position: relative;
}

.icon-container {
    margin-bottom: 32px;
}

.suspend-icon {
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, #f16a52, #e85a42);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    box-shadow:
        0 12px 32px rgba(241, 106, 82, 0.25),
        0 4px 12px rgba(241, 106, 82, 0.15);
    position: relative;
    transform: rotate(-2deg);
}

.suspend-icon::after {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    background: linear-gradient(135deg, #f16a52, #e85a42);
    border-radius: 22px;
    z-index: -1;
    opacity: 0.2;
    transform: rotate(4deg);
}

.suspend-title {
    font-size: 26px;
    font-weight: 700;
    color: #1f2937;
    margin: 0 0 16px 0;
    line-height: 1.3;
    letter-spacing: -0.025em;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.suspend-description {
    font-size: 16px;
    color: #6b7280;
    line-height: 1.6;
    margin: 0 0 40px 0;
    font-weight: 400;
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
}

.contact-info {
    background: #fafbfc;
    padding: 32px;
    border-radius: 12px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow:
        0 2px 8px rgba(0, 0, 0, 0.04),
        0 1px 3px rgba(0, 0, 0, 0.02);
    position: relative;
}

.contact-info::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #f16a52, #e85a42);
    border-radius: 12px 12px 0 0;
}

.contact-item {
    display: flex;
    align-items: center;
    text-align: left;
    gap: 16px;
}

.contact-icon {
    width: 40px;
    height: 40px;
    background: #fff;
    border: 1px solid rgba(241, 106, 82, 0.15);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}

.contact-details {
    flex: 1;
}

.contact-label {
    font-size: 13px;
    font-weight: 600;
    color: #6b7280;
    margin-bottom: 4px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.contact-value {
    font-size: 16px;
    font-weight: 600;
    color: #f16a52;
    font-family: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;
    letter-spacing: -0.01em;
}

.contact-divider {
    height: 1px;
    background: linear-gradient(90deg, transparent, #e5e7eb, transparent);
    margin: 24px 0;
}

.contact-button-container {
    margin-top: 24px;
    display: flex;
    justify-content: center;
}

.contact-button {
    background: transparent;
    border: 1px solid #f16a52;
    border-radius: 8px;
    color: #f16a52;
    padding: 10px 20px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s ease;
    font-family: inherit;
}

.contact-button:hover {
    background: #f16a52;
    color: white;
}

.contact-button:active {
    background: #e85a42;
    border-color: #e85a42;
    color: white;
}

.contact-button-icon {
    font-size: 16px;
}


@media (max-width: 768px) {
    .suspend-container {
        background-size: 16px 16px;
    }

    .suspend-content {
        padding: 32px 24px;
        margin: 20px;
        border-radius: 10px;
    }

    .suspend-title {
        font-size: 24px;
    }

    .company-logo-header {
        margin-bottom: 24px;
        padding: 12px 20px;
    }

    .company-logo-header img {
        height: 48px;
    }

    .suspend-description {
        font-size: 15px;
    }

    .contact-info {
        padding: 24px 20px;
    }

    .contact-value {
        font-size: 15px;
    }

    .suspend-icon {
        width: 70px;
        height: 70px;
        border-radius: 16px;
    }

    .contact-item {
        gap: 12px;
    }

    .contact-icon {
        width: 36px;
        height: 36px;
    }

    .contact-button {
        padding: 9px 18px;
        font-size: 14px;
    }
}

@media (max-width: 480px) {
    .suspend-container {
        background-size: 14px 14px;
    }

    .suspend-content {
        padding: 24px 20px;
        margin: 16px;
    }

    .suspend-title {
        font-size: 22px;
    }

    .company-logo-header {
        margin-bottom: 20px;
        padding: 10px 16px;
    }

    .company-logo-header img {
        height: 40px;
    }

    .contact-value {
        font-size: 14px;
        word-break: break-all;
    }

    .contact-item {
        flex-direction: column;
        text-align: center;
        gap: 8px;
    }

    .contact-details {
        text-align: center;
    }

    .contact-button {
        padding: 8px 16px;
        font-size: 13px;
    }
}
</style>
